import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import {
  FeatureAccessService,
  FeatureRequirement,
} from '../_services/feature-access.service';

export const featureGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const featureAccess = inject(FeatureAccessService);

  const requirement = route.data?.['feature'] as FeatureRequirement | undefined;

  if (!requirement) {
    return true;
  }

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login'], {
      queryParams: { redirectTo: state.url },
    });
  }

  if (featureAccess.has(requirement)) {
    return true;
  }

  return router.createUrlTree(['/private']);
};
